import { render, staticRenderFns } from "./Laporan.vue?vue&type=template&id=1be17b29&scoped=true"
import script from "./Laporan.vue?vue&type=script&lang=js"
export * from "./Laporan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be17b29",
  null
  
)

export default component.exports